import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { sortRecipes } from '@mindfulchefuk/actions/recipesActions'
import { logRecipesSortChange } from '@mindfulchefuk/features/Onboarding/utils/onboardingAnalytics'
import { TOnboardingRecipeFilterHandlers } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesFilters/OnboardingRecipeFilterHandlers.types'

export const useOnSortByChange =
  (): TOnboardingRecipeFilterHandlers['sortBy'] => {
    const dispatch = useDispatch()

    const onSortByChange = useCallback<
      TOnboardingRecipeFilterHandlers['sortBy']
    >(
      (newSortBy) => {
        logRecipesSortChange(newSortBy)

        dispatch(sortRecipes(newSortBy))
      },
      [dispatch]
    )

    return onSortByChange
  }
